import { ListActionTarget } from '../../../models/ListActionTarget';

export const CHANGE_TARGET = 'CHANGE_TARGET';
export const SET_TARGET_SELECTION_LIST_ID = 'SET_TARGET_SELECTION_LIST_ID';

interface ChangeTargetAction {
    type: typeof CHANGE_TARGET;
    target: ListActionTarget;
}

interface SetTargetSelectionListId {
    type: typeof SET_TARGET_SELECTION_LIST_ID;
    selectionListId: string;
}

export type AddToCartOrListAction = ChangeTargetAction | SetTargetSelectionListId;
